import * as React from 'react';
import {Icon} from '@openfin/desktop-ui';

import {ClassNameBuilder} from '../../utils/ClassNameBuilder';

import * as Styles from './Sidebar.module.scss';

export interface SidebarProps {
    items: SidebarItemProps[];
}

export const Sidebar: React.FC<SidebarProps> = (props) => {
    const {items} = props;

    return (
        <div className={Styles['sidebar']}>
            {items.map((item) => <SidebarItem {...item} key={item.label} />)}
        </div>
    );
};

export interface SidebarItemProps {
    image: string;
    label: string;
    onClick?: () => void;
    selected?: boolean | (() => boolean);
}

export const SidebarItem: React.FC<SidebarItemProps> = (props) => {
    const {image, label, onClick, selected = false} = props;
    const isSelected = typeof selected === 'function' ? selected() : selected;
    const classNames = new ClassNameBuilder(Styles, 'sidebar-item', ['selected', isSelected]);

    return (
        <div className={classNames.toString()}>
            <Icon className={Styles['icon']} src={image} size={20} onClick={onClick} />
            <div className={Styles['sidebar-label']}>
                {label}
            </div>
        </div>
    );
};
